import { keyframes, styled } from "styled-components";
import { Heading } from "../../global";

const pulse = keyframes`
   0% { transform: scale(1); }
  50% { transform: scale(1.5); }
  100% { transform: scale(1); }
`;

const Pulse = styled(Heading)`
  display: flex;
  width: 80%;
  justify-content: center;
  animation-name: ${(props) => (props.$trigger !== 0 ? pulse : null)};
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  align-items: center;
`;

export { Pulse };
